import { EnvironmentUrlsContext, EnvironmentUrlsProviderProps } from './EnvironmentUrlsContext';

// The URLs differ per environment (AWS vs the Azure sandbox), so the host app reads them from its env files
// and injects them here. shared never reads import.meta.env.
export default function EnvironmentUrlsProvider({ environmentUrls, children }: EnvironmentUrlsProviderProps) {
  return <EnvironmentUrlsContext.Provider value={environmentUrls}>{children}</EnvironmentUrlsContext.Provider>;
}
